import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


export default function PeriodoVigente(props) {
  const rows = props.empperiodo;
  return (

    <TableContainer component={Paper} style={{ padding: '3px' }}>

      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead style={{ backgroundColor: 'rgba(128, 129, 146, 0.2)' }}>
          <TableRow>
            <TableCell>Fecha</TableCell>
            <TableCell align="right">Periodo</TableCell>
            <TableCell align="right">Tipo</TableCell>
            <TableCell align="right">Concepto</TableCell>
            <TableCell align="right">Cantidad</TableCell>
            <TableCell align="right">Monto</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, Index) => (
            <TableRow
              hover
              key={Index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.fecha}
              </TableCell>
              <TableCell align="right">{row.periodo}</TableCell>
              <TableCell align="right">{row.tipo}</TableCell>
              <TableCell align="right">{row.concepto}</TableCell>
              <TableCell align="right">{row.cantidad}</TableCell>
              <TableCell align="right">${row.monto}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}